import React from 'react';
import PublicNavbar from './PublicNavbar';
import PublicFooter from './PublicFooter';

interface Props { children: React.ReactNode; }

const PublicLayout: React.FC<Props> = ({ children }) => (
  <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
    <PublicNavbar />
    <main style={{ flex: 1 }}>{children}</main>
    <PublicFooter />
  </div>
);

export default PublicLayout;
